import { render, staticRenderFns } from "./extra-gesundbox.vue?vue&type=template&id=6b161ddc&lang=pug&"
import script from "./extra-gesundbox.vue?vue&type=script&lang=js&"
export * from "./extra-gesundbox.vue?vue&type=script&lang=js&"
import style0 from "./extra-gesundbox.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports